var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"width":"100% !important","position":"relative"},style:({height:_vm.mapHeight}),attrs:{"id":_vm.identyMap}})])
}
var staticRenderFns = []

export { render, staticRenderFns }